import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import Cookies from 'js-cookie';
import { useRouter } from 'next/dist/client/router';
import { omit } from 'ramda';
import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import useRolePermission from 'src/hooks/useRolePermission';
import { setUpSentryUser } from 'src/lib/sentry';
import { MenuID } from 'src/types';
import { getUserName } from 'src/utils';
import API from '../api/API';
import { BranchConstants, cookiesOptions, HASURA_COOKIE_NAME } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export var UserDataContext = /*#__PURE__*/createContext({});

var UserDataContextProvider = function UserDataContextProvider(_ref) {
  var _Cookies$get, _Cookies$get2, _Cookies$get3;

  var children = _ref.children;

  var _useState = useState((_Cookies$get = Cookies === null || Cookies === void 0 ? void 0 : (_Cookies$get2 = Cookies.get) === null || _Cookies$get2 === void 0 ? void 0 : _Cookies$get2.call(Cookies, 'access_token')) !== null && _Cookies$get !== void 0 ? _Cookies$get : undefined),
      access_token = _useState[0],
      setAccessToken = _useState[1];

  var _useState2 = useState(!!(Cookies !== null && Cookies !== void 0 && (_Cookies$get3 = Cookies.get) !== null && _Cookies$get3 !== void 0 && _Cookies$get3.call(Cookies, 'access_token'))),
      authenticated = _useState2[0],
      setAuthenticated = _useState2[1];

  var _useState3 = useState([]),
      role = _useState3[0],
      setRole = _useState3[1];

  var _useState4 = useState(null),
      profile = _useState4[0],
      setProfile = _useState4[1];

  var _useState5 = useState(''),
      name = _useState5[0],
      setName = _useState5[1];

  var _useRolePermission = useRolePermission(role),
      can = _useRolePermission.can;

  var setRoleTypes = function setRoleTypes(roles) {
    var filteredRoles = roles.filter(function (item) {
      return item.resource_type === 'Org' && item.resource_id === +BranchConstants.ORG_ID;
    }).map(function (item) {
      return item.name;
    });
    setRole(filteredRoles);
  };

  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$API$getUserPro, userInfo;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!access_token) {
                _context.next = 12;
                break;
              }

              _context.next = 3;
              return API.getUserProfile(access_token);

            case 3:
              _yield$API$getUserPro = _context.sent;
              userInfo = _yield$API$getUserPro.data;
              Cookies.set('id', encodeURI(userInfo.id.toString()), cookiesOptions);
              Cookies.set('uid', encodeURI(userInfo.uid), cookiesOptions);
              setUpSentryUser({
                id: userInfo.id.toString(),
                username: getUserName(userInfo),
                email: userInfo.email,
                roles: userInfo.roles.map(function (role) {
                  return {
                    name: role.name,
                    org_id: role.org_id
                  };
                })
              });
              setAuthenticated(true);
              setProfile(userInfo);
              setName(getUserName(userInfo));
              setRoleTypes(userInfo.roles);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [access_token]);

  var _useRouter = useRouter(),
      push = _useRouter.push;

  var setUpAccessToken = useCallback(function (value) {
    setAccessToken(value);

    if (value) {
      localStorage.setItem('accessToken', value);
    } else {
      localStorage.removeItem('accessToken');
    }
  }, []);

  var logout = function logout() {
    setUpAccessToken();
    setRole([]);
    setAuthenticated(false);
    Cookies.remove('access_token', cookiesOptions);
    Cookies.remove(HASURA_COOKIE_NAME, cookiesOptions);
    Cookies.remove('authorized', cookiesOptions);
    Cookies.remove('name', cookiesOptions);
    Cookies.remove('nick_name', cookiesOptions);
    Cookies.remove('orgCODE', omit(['domain'], cookiesOptions)); // omit 'domain', because 'orgCODE' should not be shared, though other cookies are shared on '.vercel.cofit.me'

    Cookies.remove('img');
    push(MenuID.login);
  };

  return /*#__PURE__*/_jsx(UserDataContext.Provider, {
    value: {
      access_token: access_token,
      authenticated: authenticated,
      role: role,
      can: can,
      profile: profile,
      logout: logout,
      setUpAccessToken: setUpAccessToken,
      setRole: setRoleTypes,
      name: name
    },
    children: children
  });
};

var useUserDataContextProvider = function useUserDataContextProvider() {
  var context = useContext(UserDataContext);
  return _objectSpread({}, context);
};

export { useUserDataContextProvider };
export default UserDataContextProvider;